import React from 'react';
import ShowArticleStockAmountProperties from "./ShowArticleStockAmountProperties";
import {useStyles} from "./ShowArticleStockAmount.style";
import clsx from "clsx";
import { useUserContext } from '../../../contexts/UserContext';
import Access from '../../Access/AllowAccess/Access';

const ShowArticleStockAmount: React.FC<ShowArticleStockAmountProperties> = ({
                                                      physicalAmount,
                                                      bookAmount,
                                                      className = '',
                                                  }) => {

    const classes = useStyles();
    const userStore = useUserContext();

    if (!userStore.hasAccess(Access.GET_ARTICLE_STOCK.valueOf())) {
        return <></>
    }

    return (
        <div className={clsx(classes.show_price_container, className)}>
            <div>
                <div className={classes.title}>{'Existencia Física'}</div>
                <div className={clsx(
                    classes.number,
                    ((physicalAmount ?? 0) >= 0) && classes.positive,
                    ((physicalAmount ?? 0) < 0) && classes.negative,
                )}>{physicalAmount ?? 0}</div>
            </div>

            <div>
                <div className={classes.title}>{'Artículos en Faltante'}</div>
                <div className={clsx(
                    classes.number,
                    ((bookAmount ?? 0) >= 0) && classes.positive,
                    ((bookAmount ?? 0) < 0) && classes.negative,
                )}>{bookAmount ?? 0}</div>
            </div>
        </div>
    )
}


export default ShowArticleStockAmount;